import { useState } from 'react';
import { useStyles, CancelButton, ConfirmButton } from './GradeRules.styles';
import { Button, Grid } from '@material-ui/core';
import { ReactComponent as DownloadIcon } from '../../../assets/icons/download.svg';
import { Modal } from '../../Modal/Modal.component';
import { downloadGradeRulesFile } from '../../../services/exams/assessmentSession/assessments.service';
import { Prompt } from '../../Prompt/Prompt.component';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { fill, fillOpacity } from '../../../utils/contrastSvgAttributes';
import { highContrastMode } from '../../../utils/highContrastChecker';

export const GradeRules: React.FC<{ gradeRulesId: string; fileName: string | null }> = (props) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);
  const [isDownloadErrorOpen, setIsDownloadErrorOpen] = useState<boolean>(false);

  const classes = useStyles();
  const assessmentSession = useSelector((state: RootState) => state.assessmentSession.assessmentSession);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const download = async () => {
    if (props.fileName && assessmentSession) {
      try {
        await downloadGradeRulesFile(assessmentSession.assessmentSessionId, props.fileName);
      } catch (error) {
        setIsDownloadErrorOpen(true);
      } finally {
        setOpen(false);
      }
    }
  };

  return (
    <>
      <Button
        className={highContrastMode ? `${classes.iconButton} ${classes.iconButtonContrast}` : classes.iconButton}
        startIcon={<DownloadIcon fill={fill} className={classes.downloadIcon} />}
        disabled={props.fileName === null}
        onClick={handleOpen}
      >
        Zasady oceniania
      </Button>

      <Modal open={open} size="xs" autoHeight={true}>
        <div className={classes.infoMessage}>Pobierz zasady oceniania dla arkusza:</div>
        <div className={classes.nameText}>{props.fileName}</div>
        <Grid container>
          <Grid item xs={6}>
            <CancelButton onClick={handleClose}>Anuluj</CancelButton>
          </Grid>
          <Grid item xs={6}>
            <ConfirmButton onClick={download}>Pobierz plik</ConfirmButton>
          </Grid>
        </Grid>
      </Modal>

      <Prompt
        type="error"
        isBold={true}
        open={isDownloadErrorOpen}
        mainText={`Wystąpił błąd w pobieraniu pliku. Spróbuj ponownie później.`}
        onConfirm={() => setIsDownloadErrorOpen(false)}
        mainActionButtonText="POWRÓT DO RGZ"
      />
    </>
  );
};
